<template>
    <v-card>
        <v-card-title>{{ $t('choose_role') }}</v-card-title>
        <v-card-subtitle>Sie sind:</v-card-subtitle>
        <v-card-text>
            <v-radio-group v-model:model-value="modelValue">
                <v-radio v-for="r in getRollen()" :key="r.ident" :value="r.ident">
                    <template v-slot:label>
                        <span style="min-width: 150px">{{ r.text }}</span>
                        <field-info-icon v-if="r.help" html :infotext="r.help" bottom />
                    </template>
                </v-radio>
            </v-radio-group>
        </v-card-text>
        <v-card-actions>
            <v-btn
                color="action white--text"
                variant="flat"
                @click="$emit('back')"
                prepend-icon="fas fa-arrow-left"
            >
                {{ $t('back') }}
            </v-btn>
            <v-btn
                color="action white--text"
                variant="flat"
                :disabled="!modelValue"
                @click="$emit('next')"
                append-icon="fas fa-arrow-right"
            >
                {{ $t('next') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="ts">
import { SICHTBARKEIT } from '@/models/apollon_conf_fk/KontaktConfig'
import type { ApollonConfFk } from '@/models/ApollonConfFk'
import FieldInfoIcon from '@/components/field-info-icon.vue'
import { useI18n } from 'vue-i18n'

const modelValue = defineModel<string | null>()

const { apollonConfFk } = defineProps<{
    apollonConfFk: ApollonConfFk[] | null
}>()

defineEmits<{
    (e: 'next'): void
    (e: 'back'): void
}>()

const { t } = useI18n()

function getRollen() {
    const res: { [key: string]: { ident: string; text: string; help: string | null } } = {}
    if (!apollonConfFk || !Array.isArray(apollonConfFk) || apollonConfFk.length !== 1) {
        return res
    }
    const conf = apollonConfFk[0]

    if (
        conf.kontakte?.eigentuemer?.sichtbarkeit === SICHTBARKEIT.IMMER ||
        conf.kontakte?.eigentuemer?.sichtbarkeit === SICHTBARKEIT.EINREICHUNG
    ) {
        res['eigentuemer'] = {
            ident: 'eigentuemer',
            text: conf.kontakte.eigentuemer.label || t('eigentuemer'),
            help: conf.kontakte.eigentuemer.hilfetext_kurz,
        }
    }
    if (
        conf.kontakte?.unternehmer?.sichtbarkeit === SICHTBARKEIT.IMMER ||
        conf.kontakte?.unternehmer?.sichtbarkeit === SICHTBARKEIT.EINREICHUNG
    ) {
        res.unternehmer = {
            ident: 'unternehmer',
            text: conf.kontakte.unternehmer.label || t('unternehmer'),
            help: conf.kontakte.unternehmer.hilfetext_kurz,
        }
    }
    if (
        conf.kontakte?.bevollmaechtigter?.sichtbarkeit === SICHTBARKEIT.IMMER ||
        conf.kontakte?.bevollmaechtigter?.sichtbarkeit === SICHTBARKEIT.EINREICHUNG
    ) {
        res.bevollmaechtigter = {
            ident: 'bevollmaechtigter',
            text: conf.kontakte.bevollmaechtigter.label || t('bevollmaechtigter'),
            help: conf.kontakte.bevollmaechtigter.hilfetext_kurz,
        }
    }
    if (
        conf.kontakte?.kontakt?.sichtbarkeit === SICHTBARKEIT.IMMER ||
        conf.kontakte?.kontakt?.sichtbarkeit === SICHTBARKEIT.EINREICHUNG
    ) {
        res.kontakt = {
            ident: 'kontakt',
            text: conf.kontakte.kontakt.label || t('kontakt'),
            help: conf.kontakte.kontakt.hilfetext_kurz,
        }
    }
    return res
}
</script>
